<template>
  <div class="equipment-list">
    <span>אביזרים נדרשים:</span>
    <img
      v-for="item in list"
      :src="`${base}assets/yoga/images/videos/${item.alias}.png`"
      :alt="item.label"
      :title="item.label"
      class="equipment-icon"
      :key="item.id"
    />
  </div>
</template>

<script>
export default {
  name: `EquipItem`,
  props: {
    list: Array,
    base: String,
  },
};
</script>

<style lang="scss">
.equipment-list {
  display: flex;
  align-items: center;
}
.equipment-icon {
  filter: brightness(0);
  margin-right: 0.6rem;
  transform: scale(0.85);
}
</style>
